import { connectNumericMenu } from 'instantsearch.js/es/connectors';

const locationAvailabilityNumericMenu = function(params: {
  container: string;
  label: string;
  locationId?: number;
  attribute?: string;
}) {
  const { container, locationId, attribute, label } = params;
  // renderer for the connector
  const render = (renderOptions: any, isFirstRender: boolean) => {
    const { items: renderedItems, refine, widgetParams } = renderOptions;
    const containerNode =
      typeof widgetParams.container === 'string'
        ? document.querySelector(widgetParams.container)
        : widgetParams.container;

    if (!containerNode) {
      return;
    }

    // Clear container on first render
    if (isFirstRender) {
      containerNode.classList.add('ais-NumericMenu-item');
      containerNode.innerHTML = '';
    }

    // Rebuild UI each render (simple and safe)
    containerNode.innerHTML = '';

    // The container is the li
    const divContainer = document.createElement('div');

    renderedItems.forEach((item: any) => {
      const label = document.createElement('label');
      label.className = 'ais-NumericMenu-label';

      const input = document.createElement('input');
      input.type = 'radio';
      input.name = 'location';
      input.className = 'ais-NumericMenu-radio';
      input.checked = !!item.isRefined;
      // Save checked state in data attribute because radio buttons change input.checked before the event fires
      input.dataset.checked = input.checked.toString();

      const span = document.createElement('span');
      span.className = 'ais-NumericMenu-labelText';
      span.textContent = item.label;

      label.appendChild(input);
      label.appendChild(span);
      divContainer.appendChild(label);

      // When the one you click on changes, we loop through all of them, and turn off the refinements for the others
      // It only fires the change even for the one you've selected
      input.addEventListener('change', () => {
        const allRadioButtons = document.querySelectorAll<HTMLInputElement>('input[name="location"]');
        allRadioButtons.forEach((radio) => {
          if (radio === input) {
            console.debug('Refining to value:', item.value);
            // apply this numeric refinement
            refine(item.value);
          } else {
            // Fire a 'deselect' event to uncheck other radio buttons
            radio.dispatchEvent(new CustomEvent('deselect'));
          }
        });
      });
      input.addEventListener('deselect', (e) => {
        const target = e.target as HTMLInputElement;
        // console.debug('Deselect fired for', target);
        // console.debug('Current checked state:', target.dataset.checked);
        // Remove the refinement if it's currently enabled
        if (target.dataset.checked === 'true') {
          // console.debug('Deselecting, removing refinement', target);
          target.checked = false;
          target.dataset.checked = 'false';
          // This is URI-encoded '{}', which means no numeric refinements on this attribute
          refine('%7B%7D');
        }
      });
    });

    containerNode.appendChild(divContainer);
  };

  const unmount = (options: any) => {
    const containerNode =
      typeof options.container === 'string'
        ? document.querySelector(options.container)
        : options.container;
    if (containerNode) {
      containerNode.innerHTML = '';
    }
  };

  // @ts-ignore
  const customNumericMenu = connectNumericMenu(render, unmount);

  const item = {
    label,
    start: 1,
  };

  return customNumericMenu({
    // @ts-ignore
    container,
    attribute: attribute || `locations_inventory.${locationId}`,
    items: [item],
  });
};

// Example usage:
// <div class="filters__checklist" id="filters-byPrice">
//   <div class="ais-NumericMenu">
//     <ul class="ais-NumericMenu-list">
//       <li id="filters-location-cambridge"></li>
//       <li id="filters-location-waterloo"></li>
//       <li id="filters-location-montreal"></li>
//     </ul>
//   </div>
// </div>
// locationAvailabilityNumericMenu(
//   '#filters-location-cambridge',
//   78254014757,
//   t('algolia:filters.availableLocation.options.FLAGSHIP_BOUTIQUE'),
// ),

export default locationAvailabilityNumericMenu;
